import React from 'react';

const PageHeader = ({ children, title, subtitle }) => {
  return (
    <div className="page-head col-12 mb-3">
      <div className="page-title" style={{ width: 'auto' }}>
        <h1 className="pull-left mt-2">
          {title}
          {subtitle && ' - '}
          {subtitle && <small>{subtitle}</small>}
        </h1>
        {children}
      </div>
    </div>
  );
};

export default PageHeader;



// WEBPACK FOOTER //
// src/modules/common/components/PageHeader.js